import { useLegacyUrl } from '@ms/yammer-hooks/dist/urls';
import { FC } from 'react';

export interface OutboundLegacyRedirectProps {
  readonly target: string;
}

const OutboundLegacyRedirect: FC<OutboundLegacyRedirectProps> = ({ target }) => {
  const path = useLegacyUrl(`/${target}`);
  window.location.replace(path);

  return null;
};

export default OutboundLegacyRedirect;
